import "./PlanDetails.scss";

import React from "react";

import {
  Grid2,
  Typography
} from "@mui/material";

import AlertComponent from "../../shared/components/alert-component/AlertComponent";
import AsideContent from "../../shared/components/aside-content/AsideContent";
import ContentBlock from "../../shared/components/content-block/ContentBlock";
import {
  FeatureToggle,
  PlanDetailsContent,
  PhSiteSettings
} from "../../shared/models/app-data-model";
import { Script } from "gatsby";

export type PlanDetailsProps = {
  content: PlanDetailsContent;
  featureToggles: FeatureToggle[];
  phSiteSettings: PhSiteSettings;
};

const PlanDetails: React.FC<PlanDetailsProps> = (props: PlanDetailsProps) => {
  const url = props.content.url;
  const asideContent = <AsideContent asideContent={props.content.aside_content} />;
  const pageAlert = props.content.page_alert;
  const planShortDescription = props.content.plan_short_description;
  const pageAlertData = pageAlert && pageAlert.map((alert, index) =>
    alert.alert_reference.length > 0 ? <AlertComponent message={alert.alert_reference[0]?.alert_message} severityLevel={alert.alert_reference[0]?.alert_type} button={alert.alert_reference[0]?.button} key={index}></AlertComponent> : null);

  const contents = props.content.page_content && props.content.page_content.content_block.length > 0
    ? props.content.page_content.content_block.map((item, index) => <ContentBlock featureToggles={props.featureToggles} contentBlock={item} key={index} phSiteSettings={props.phSiteSettings} />)
    : null;
  
  const appData = props.content.app_data; 
  const quickQuoteScriptUrl = `${props.phSiteSettings.plan_details_app_connector}/agent-info.js`;
  const agentInfoScriptUrl = `${props.phSiteSettings.plan_details_app_connector}/quick-quote.js`;

  const contentHeader = props.content.page_content && props.content.page_content.content_header;
  const apiSource = props.phSiteSettings.app_connector_api_data_source || "www.priorityhealth.com";

  return (
    <>
      <Grid2 container rowSpacing={2} columnSpacing={3} className='plan-details' maxWidth="xl">
        
        <Grid2 container maxWidth="xl" className='hero'>
          <Grid2 className="content app-connector">
            <div data-app-config={appData} data-api-source={apiSource}></div>
            <Script src={quickQuoteScriptUrl}></Script>
            
          </Grid2>
        </Grid2>

        <Grid2 container size={{ xs: 12}}>
          {pageAlertData}
        </Grid2>
    
        <Grid2 container size={{ xs: 12, md: 4, lg:3 }} component='aside' className="page-aside">
          <div className="app-connector" data-app-config="agent-info" data-api-source={apiSource}></div>
          <Script src={agentInfoScriptUrl}></Script>
          {asideContent}
        </Grid2>

        <Grid2 container className="page-content" size='grow' component='main'>
          <Typography component='p' className="lead">{planShortDescription}</Typography>
          {contentHeader && <h2 className="page-content-header">{contentHeader}</h2>}
          {contents}
        </Grid2>
      </Grid2>
    </>
  );
};

export default PlanDetails;
